<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.21 19.68"
    >
        <path
            id="Path_775"
            data-name="Path 775"
            class="cls-1"
            d="M15.61,5.62A1.23,1.23,0,0,0,14,5.9L11.71,8.08,11.66,2V1.21a1.22,1.22,0,0,0-.36-.86,1.2,1.2,0,0,0-1.7,0h0l-.05,0a1.25,1.25,0,0,0-.31.82V3.36l0,.11,0,4.64L7,5.94a1.22,1.22,0,0,0-1.7-.23A1.2,1.2,0,0,0,5,7.34l0,.07,4.54,4.4a1.18,1.18,0,0,0,1,.47h0a1.21,1.21,0,0,0,1-.48l4.44-4.43L16,7.28a1.2,1.2,0,0,0-.38-1.65h0"
        />
        <path
            id="Path_776"
            data-name="Path 776"
            class="cls-1"
            d="M.64,19.67a.68.68,0,0,1-.45-.15A.5.5,0,0,1,0,19.09a.57.57,0,0,1,.18-.4.68.68,0,0,1,.45-.17.71.71,0,0,1,.46.17.55.55,0,0,1,0,.78s0,0,0,.05a.63.63,0,0,1-.45.15"
        />
        <path
            id="Path_777"
            data-name="Path 777"
            class="cls-1"
            d="M7.25,17.8a1.47,1.47,0,0,1-.15.58,2,2,0,0,1-.46.61,2.27,2.27,0,0,1-.8.49,2.94,2.94,0,0,1-1.14.19,5.35,5.35,0,0,1-.89-.08,2.45,2.45,0,0,1-.73-.26,2.27,2.27,0,0,1-.6-.47,2.52,2.52,0,0,1-.42-.59,3.25,3.25,0,0,1-.26-.7,3.48,3.48,0,0,1-.09-.79,3.16,3.16,0,0,1,.22-1.21,2.72,2.72,0,0,1,.62-.92,3,3,0,0,1,1-.58,3.6,3.6,0,0,1,1.17-.2A3.09,3.09,0,0,1,6,14.14a2.39,2.39,0,0,1,.9.67,1.2,1.2,0,0,1,.31.76.56.56,0,0,1-.62.5.52.52,0,0,1-.26-.1,1.22,1.22,0,0,1-.27-.36A1.81,1.81,0,0,0,5.49,15a1.67,1.67,0,0,0-.82-.21,1.61,1.61,0,0,0-1.24.53A2.22,2.22,0,0,0,3,16.82a2.67,2.67,0,0,0,.2,1.09,1.36,1.36,0,0,0,.58.65,1.67,1.67,0,0,0,.87.21,1.67,1.67,0,0,0,.92-.24,1.47,1.47,0,0,0,.57-.71,1.07,1.07,0,0,1,.2-.36.49.49,0,0,1,.38-.14.62.62,0,0,1,.39.14.42.42,0,0,1,.17.34"
        />
        <path
            id="Path_778"
            data-name="Path 778"
            class="cls-1"
            d="M13.1,17.89a1.59,1.59,0,0,1-.29.92,1.92,1.92,0,0,1-.85.64,3.52,3.52,0,0,1-1.33.23,3.34,3.34,0,0,1-1.52-.31,2,2,0,0,1-.69-.6A1.27,1.27,0,0,1,8.16,18a.5.5,0,0,1,.16-.36.59.59,0,0,1,.4-.15.6.6,0,0,1,.34.11A1.16,1.16,0,0,1,9.3,18a2.51,2.51,0,0,0,.26.45,1,1,0,0,0,.39.3,1.52,1.52,0,0,0,.66.12,1.54,1.54,0,0,0,.91-.24.68.68,0,0,0,.35-.59.56.56,0,0,0-.19-.45,1.47,1.47,0,0,0-.49-.27c-.2-.06-.47-.13-.8-.2a7.54,7.54,0,0,1-1.12-.33,1.85,1.85,0,0,1-.72-.52,1.23,1.23,0,0,1-.26-.81,1.38,1.38,0,0,1,.28-.82,1.68,1.68,0,0,1,.81-.55,3.55,3.55,0,0,1,1.25-.19,3.64,3.64,0,0,1,1,.13,2.47,2.47,0,0,1,.69.34,1.56,1.56,0,0,1,.4.45,1.06,1.06,0,0,1,.13.46.51.51,0,0,1-.16.37.57.57,0,0,1-.73.06,1.08,1.08,0,0,1-.24-.32,1.64,1.64,0,0,0-.41-.5,1.34,1.34,0,0,0-.76-.18,1.56,1.56,0,0,0-.79.19.55.55,0,0,0-.3.47.43.43,0,0,0,.1.29.83.83,0,0,0,.28.21,1.78,1.78,0,0,0,.36.14l.6.15c.32.07.64.15,1,.25a3.13,3.13,0,0,1,.72.33,1.57,1.57,0,0,1,.47.49,1.39,1.39,0,0,1,.17.72"
        />
        <path
            id="Path_779"
            data-name="Path 779"
            class="cls-1"
            d="M15.09,14.61l1.41,3.77,1.41-3.79c.05-.14.11-.28.17-.42a.6.6,0,0,1,.18-.21.54.54,0,0,1,.35-.09.73.73,0,0,1,.3.07.59.59,0,0,1,.22.19.43.43,0,0,1,.08.24.52.52,0,0,1,0,.18l-.06.19a1.54,1.54,0,0,1-.08.19l-1.5,3.67c-.05.14-.11.27-.16.4a1.35,1.35,0,0,1-.19.33.72.72,0,0,1-.28.24.8.8,0,0,1-.43.09,1.07,1.07,0,0,1-.43-.09.8.8,0,0,1-.28-.24,1.35,1.35,0,0,1-.19-.33c-.05-.13-.11-.26-.16-.4L13.93,15l-.08-.2a1.72,1.72,0,0,1-.07-.21.58.58,0,0,1,0-.19.49.49,0,0,1,.17-.35.6.6,0,0,1,.44-.16.56.56,0,0,1,.46.18,3.38,3.38,0,0,1,.27.58"
        />
    </svg>
</template>

<script>
export default {
    name: 'CsvIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 19.21px;
    height: 19.68px;
    margin: auto;
    path {
        fill: $white;
    }
}
svg:hover {
    path {
        fill: $blue;
    }
}
</style>